import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'customerCode': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    width: 170,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'customerName': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'customerTypeName': {
    title: '客户类型',
    width: 200,
  },
  'saleCenterName': {
    title: '营销单元',
    width: 200,
  },
  'baseName': {
    title: '基地',
    width: 200,
  },
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/base-setting/config/shuntCustomLimits.js